import React from "react";
import {useTranslation} from "react-i18next";
import {User} from "../../../models/User";
import {PlayerItem, FriendState} from "../PlayerItem";

type FriendsListType = {
    friends: User[];
    removeFriend: (user: User) => void;
}


export const FriendsList: React.FC<FriendsListType> = (props) => {
    const {t} = useTranslation();

    return (
        <>
            {props.friends.length === 0 ?
                <div className="flex flex-col justify-end items-center h-1/2">
                    <p className="text-2xl text-center">{t("players.you-have-no-friends")}</p>

                    <img
                        className="h-1/2"
                        src="/images/sad_cat.png"
                        alt=""
                    />
                </div>
                :
                <div className={"flex flex-col gap-5"}>
                    {props.friends.map(user => (
                        <PlayerItem
                            user={user}
                            friendState={FriendState.isFriends}
                            removeFriend={props.removeFriend}
                        />
                    ))}
                </div>
            }
        </>
    )
}
